<template>
  <div class="compressed-content">
    <h3>What is your address?</h3>
    <div class="page-buttons">
      <v-form-group :validator="$v.address1" label="Address 1">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="survey.address.address1"
                      placeholder="Address" />
      </v-form-group>
      <v-form-group label="Address 2">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="survey.address.address2"
                      placeholder="Address" />
      </v-form-group>
      <v-form-group :validator="$v.city" label="City">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="survey.address.city"
                      placeholder="City" />
      </v-form-group>
      <div class="row">
        <div class="col-12 col-lg-8">
          <v-form-group :validator="$v.state" label="State">
            <v-select slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      :options="usaStates.map(state => ({ label: state.name, value: state.name}))"
                      :clearable="false"
                      :filterable="false"
                      :searchable="false"
                      placeholder="State"
                      :reduce="option => option.value"
                      v-model="survey.address.state" />
          </v-form-group>
        </div>
        <div class="col-12 col-lg-4">
          <v-form-group :validator="$v.zip" label="ZIP">
            <b-form-input slot-scope="{ attrs, listeners }"
                          v-bind="attrs"
                          v-on="listeners"
                          v-model="survey.address.zip"
                          placeholder="ZIP" />
          </v-form-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  import { usaStates } from 'typed-usa-states';

  import productType from 'enums/product-type';

  export default {
    mixins: [formMixin],

    data() {
      return {
        productType
      }
    },

    validations: {
      address1: {
        required
      },
      city: {
        required
      },
      state: {
        required
      },
      zip: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      address1() { return this.survey.address.address1; },
      address2() { return this.survey.address.address2; },
      city() { return this.survey.address.city; },
      state() { return this.survey.address.state; },
      zip() { return this.survey.address.zip; },
      usaStates() { return usaStates; }
    }
  };
</script>